(function () {
    'use strict';

    function initCompleteSet() {
      const completeSet = document.querySelector('[data-complete-set]');
      if (!completeSet) return;

      const trayRadios = completeSet.querySelectorAll('input[name="complete_set_tray"]');
      const colourRadios = completeSet.querySelectorAll('input[name="complete_set_colour"]');
      const trayLabel = completeSet.querySelector('.tray-label');
      const colourLabel = completeSet.querySelector('.colour-label');
      const priceDisplay = completeSet.querySelector('#cs-total-price');
      const comparePriceDisplay = completeSet.querySelector('#cs-total-compare-price');
      const productImage = completeSet.querySelector('#cs-product-image');
      const form = completeSet.querySelector('#complete-set-form');
      const mainVariantInput = form.querySelector('.cs-main-variant');

      function updateImage() {
        const selectedTray = completeSet.querySelector('input[name="complete_set_tray"]:checked');
        const selectedColour = completeSet.querySelector('input[name="complete_set_colour"]:checked');
      
        if (selectedTray && selectedTray.value !== 'none') {
          // Show tray image if tray is selected
          const trayImage = selectedTray.dataset.trayImage;
          if (trayImage && trayImage !== 'null' && trayImage !== '') {
            productImage.src = trayImage;
            return;
          }
        }
      
        // Otherwise show main variant image
        if (selectedColour && selectedColour.dataset.variantImage) {
          const imageUrl = selectedColour.dataset.variantImage;
          if (imageUrl && imageUrl !== 'null' && imageUrl !== '') {
            productImage.src = imageUrl;
          }
        }
      }
      

      // Update price
      function updatePrice() {
        const selectedColour = completeSet.querySelector('input[name="complete_set_colour"]:checked');
        const selectedTray = completeSet.querySelector('input[name="complete_set_tray"]:checked');

        let total = 0;
        let compareTotal = 0;
        if (selectedColour) {
          const colourPrice = parseFloat(selectedColour.dataset.variantPrice || 0);
          total += colourPrice;
          compareTotal += parseFloat(selectedColour.dataset.variantCompareAtPrice || colourPrice);
        }
        if (selectedTray && selectedTray.value !== 'none') {
          const trayPrice = parseFloat(selectedTray.dataset.trayPrice || 0);
          total += trayPrice;
          compareTotal += parseFloat(selectedTray.dataset.trayCompareAtPrice || trayPrice);
        }

        const formatMoney = (cents) =>
          (cents / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          });

        priceDisplay.textContent = formatMoney(total);

        if (comparePriceDisplay) {
          if (compareTotal > total) {
            comparePriceDisplay.textContent = formatMoney(compareTotal);
            comparePriceDisplay.hidden = false;
          } else {
            comparePriceDisplay.textContent = '';
            comparePriceDisplay.hidden = true;
          }
        }
      }

      // Update hidden form inputs (like your PDP addon does)
      function updateFormInputs() {
        const selectedColour = completeSet.querySelector('input[name="complete_set_colour"]:checked');
        const selectedTray = completeSet.querySelector('input[name="complete_set_tray"]:checked');

        // Remove old tray inputs
        form.querySelectorAll('.cs-tray-input').forEach((el) => el.remove());

        // Update main variant
        if (selectedColour) {
          mainVariantInput.value = selectedColour.value;
        }

        // Add tray as second item if selected
        if (selectedTray && selectedTray.value !== 'none') {
          const trayIdInput = document.createElement('input');
          trayIdInput.type = 'hidden';
          trayIdInput.name = 'items[1][id]';
          trayIdInput.value = selectedTray.value;
          trayIdInput.classList.add('cs-tray-input');
          form.appendChild(trayIdInput);

          const trayQtyInput = document.createElement('input');
          trayQtyInput.type = 'hidden';
          trayQtyInput.name = 'items[1][quantity]';
          trayQtyInput.value = '1';
          trayQtyInput.classList.add('cs-tray-input');
          form.appendChild(trayQtyInput);
        }
      }

      // Handle tray change
      trayRadios.forEach((radio) => {
        radio.addEventListener('change', () => {
          const selected = completeSet.querySelector('input[name="complete_set_tray"]:checked');
          if (!selected || selected.value === 'none') {
            trayLabel.textContent = 'None';
          } else {
            trayLabel.textContent = 'Timber';
          }
          updatePrice();
          updateFormInputs();
          updateImage();
        });
      });

      // Handle colour change
      colourRadios.forEach((radio) => {
        radio.addEventListener('change', () => {
          const selected = completeSet.querySelector('input[name="complete_set_colour"]:checked');
          if (selected) {
            colourLabel.textContent = selected.dataset.variantTitle;
          }
          updateImage();
          updatePrice();
          updateFormInputs();
        });
      });

      // Initialize
      updatePrice();
      updateFormInputs();
      updateImage();
    }

    // Initialize on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCompleteSet);
    } else {
      initCompleteSet();
    }

    // Re-initialize on section load
    document.addEventListener('shopify:section:load', initCompleteSet);
    document.addEventListener('shopify:section:reopen', initCompleteSet);
  })();